var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c("div", { staticClass: "onlyForHighScreens" }, [_vm._v(" ")]),
      _vm.$store.getters.isKiosk
        ? _c("div", { staticClass: "text-center" }, [
            _vm._m(0),
            _c("h4", { class: { "mb-6": !_vm.$store.getters.isKiosk } }, [
              _vm._v("Gesamtsumme: "),
              _c("span", { staticClass: "textFont" }, [
                _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
              ]),
            ]),
            _vm.$store.getters.isKiosk
              ? _c("h4", { staticClass: "mb-6" }, [
                  _vm._v(" Zahlung an der Kasse "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "ml-6 mr-6" }, [
              _vm._v(_vm._s(_vm.abholadresse)),
            ]),
          ])
        : [
            _c(
              "h2",
              {
                staticClass: "text-center mt-7",
                staticStyle: { "margin-bottom": "2px" },
              },
              [_vm._v("Bestellung abschließen")]
            ),
            _c("div", { staticClass: "text-center" }, [
              _c("h4", {}, [
                _vm._v("Gesamtsumme: "),
                _c("span", { staticClass: "textFont" }, [
                  _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
                ]),
              ]),
              _c("h4", { staticClass: "mb-6" }, [
                _vm._v("Zahlung bei Eintritt an der Kasse"),
              ]),
            ]),
          ],
      _c(
        "v-container",
        { staticClass: "ccontainer", attrs: { "grid-list-md": "" } },
        [
          _c(
            "div",
            { staticClass: "kioskCheckoutContainer" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "vvd orderform",
                  attrs: { vertical: "", id: "stepper" },
                  model: {
                    value: _vm.currentStep,
                    callback: function ($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep",
                  },
                },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 1, step: "1" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 1
                        },
                      },
                    },
                    [
                      _vm.$store.getters.isKiosk
                        ? _c("div", { staticClass: "nice-title titleFont" }, [
                            _vm._v(
                              "Optional kannst du deinen Namen für die Abholung eingeben "
                            ),
                          ])
                        : _c("div", { staticClass: "nice-title small" }, [
                            _vm._v("Deine Bestelldaten"),
                          ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "1" } }, [
                    _vm.usecase.length > 0
                      ? _c("div", { attrs: { id: "checkData" } }, [
                          _c(
                            "div",
                            { staticClass: "bestelldaten pt-1" },
                            [
                              _c(
                                "v-form",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showForm,
                                      expression: "showForm",
                                    },
                                  ],
                                  ref: "orderDataForm",
                                  attrs: { "lazy-validation": "" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _vm.$store.getters.isKiosk
                                    ? [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            label:
                                              _vm.selfServiceEnabled &&
                                              !_vm.$store.getters.isKiosk
                                                ? "Name*"
                                                : "Name (optional)",
                                            rules: _vm.nameRules,
                                            placeholder: "Name",
                                            illed: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            focus: _vm.nameFocus,
                                            blur: _vm.unhideToolbar,
                                          },
                                          model: {
                                            value: _vm.name,
                                            callback: function ($$v) {
                                              _vm.name = $$v
                                            },
                                            expression: "name",
                                          },
                                        }),
                                        _c("h4", { staticClass: "mt-4" }, [
                                          _vm._v("Hinweise zur Bestellung"),
                                        ]),
                                        _c("v-text-field", {
                                          staticClass: "nolabel",
                                          attrs: {
                                            outlined: "",
                                            "hide-details": "",
                                            clearable: "",
                                            illed: "",
                                          },
                                          on: { focus: _vm.hinweisFocus },
                                          model: {
                                            value: _vm.note,
                                            callback: function ($$v) {
                                              _vm.note = $$v
                                            },
                                            expression: "note",
                                          },
                                        }),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "prelative" },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                value: _vm.name,
                                                label: "Vor- und Nachname*",
                                                rules: _vm.nameRules,
                                                placeholder: "Vorname Nachname",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                input: _vm.updateName,
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                            }),
                                            _vm.name
                                              ? _c(
                                                  "div",
                                                  { staticClass: "absClear" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "myBlack",
                                                        on: {
                                                          "&click": function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.name = ""
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-close ")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "prelative" },
                                          [
                                            _c("v-text-field", {
                                              ref: "email",
                                              attrs: {
                                                outlined: "",
                                                value: _vm.email,
                                                rules: _vm.emailRules,
                                                label:
                                                  "E-Mail (vorgeschrieben für Online-Zahlung)",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                input: _vm.updateEmail,
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                            }),
                                            _vm.email
                                              ? _c(
                                                  "div",
                                                  { staticClass: "absClear" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "myBlack",
                                                        on: {
                                                          "&click": function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            _vm.email = ""
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-close ")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.$store.state.enableOrderNote
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "prelative" },
                                                [
                                                  _c("v-text-field", {
                                                    ref: "phone",
                                                    attrs: {
                                                      outlined: "",
                                                      value: _vm.phone,
                                                      rules: _vm.phoneRules,
                                                      label:
                                                        _vm.selfServiceEnabled
                                                          ? "Mobilnummer*"
                                                          : "Mobilnummer (optional)",
                                                      placeholder: "",
                                                      illed: "",
                                                    },
                                                    on: {
                                                      keydown: function (
                                                        $event
                                                      ) {
                                                        return _vm.phoneKeydown(
                                                          $event
                                                        )
                                                      },
                                                      input: _vm.updatePhone,
                                                    },
                                                  }),
                                                  _vm.phone
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "absClear",
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "myBlack",
                                                              on: {
                                                                "&click":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    _vm.phone =
                                                                      ""
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c("v-text-field", {
                                                ref: "note",
                                                attrs: {
                                                  outlined: "",
                                                  "hide-details": "",
                                                  label: "Notiz",
                                                  clearable: "",
                                                  illed: "",
                                                },
                                                on: {
                                                  keyup: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    return _vm.finishStep1.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.note,
                                                  callback: function ($$v) {
                                                    _vm.note = $$v
                                                  },
                                                  expression: "note",
                                                },
                                              }),
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "prelative" },
                                                [
                                                  _c("v-text-field", {
                                                    ref: "phone",
                                                    attrs: {
                                                      outlined: "",
                                                      rules: _vm.phoneRules,
                                                      label:
                                                        _vm.selfServiceEnabled
                                                          ? "Mobilnummer*"
                                                          : "Mobilnummer (optional)",
                                                      placeholder:
                                                        "Für evtl. Rückfragen",
                                                      illed: "",
                                                    },
                                                    on: {
                                                      keydown: function (
                                                        $event
                                                      ) {
                                                        return _vm.phoneKeydown(
                                                          $event
                                                        )
                                                      },
                                                      keyup: function ($event) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        return _vm.finishStep1.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.phone,
                                                      callback: function ($$v) {
                                                        _vm.phone = $$v
                                                      },
                                                      expression: "phone",
                                                    },
                                                  }),
                                                  _vm.phone
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "absClear",
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "myBlack",
                                                              on: {
                                                                "&click":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    _vm.phone =
                                                                      ""
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                      ],
                                  _vm.isInvoiceAddressVisible
                                    ? _c(
                                        "div",
                                        { staticClass: "content" },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "mt-7 mb-4" },
                                            [_vm._v("Rechnungsadresse")]
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              rules: _vm.companyRules,
                                              label: "Firma*",
                                              illed: "",
                                              "hide-details": "",
                                              required: "",
                                            },
                                            on: {
                                              focus: _vm.hideToolbar,
                                              blur: _vm.unhideToolbar,
                                            },
                                            model: {
                                              value: _vm.invoiceAddress.company,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceAddress,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "invoiceAddress.company",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              rules: _vm.streetRules,
                                              label: "Straße und Hausnummer*",
                                              illed: "",
                                              "hide-details": "",
                                              required: "",
                                            },
                                            on: {
                                              focus: _vm.hideToolbar,
                                              blur: _vm.unhideToolbar,
                                            },
                                            model: {
                                              value: _vm.invoiceAddress.street,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.invoiceAddress,
                                                  "street",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "invoiceAddress.street",
                                            },
                                          }),
                                          _c(
                                            "table",
                                            { staticClass: "maxw myTable" },
                                            [
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        outlined: "",
                                                        rules: _vm.plzRules,
                                                        label: "PLZ*",
                                                        illed: "",
                                                        "hide-details": "",
                                                        required: "",
                                                      },
                                                      on: {
                                                        focus: _vm.hideToolbar,
                                                        blur: _vm.unhideToolbar,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.invoiceAddress
                                                            .plz,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.invoiceAddress,
                                                            "plz",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "invoiceAddress.plz",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        outlined: "",
                                                        rules: _vm.cityRules,
                                                        label: "Stadt*",
                                                        illed: "",
                                                        "hide-details": "",
                                                        required: "",
                                                      },
                                                      on: {
                                                        focus: _vm.hideToolbar,
                                                        blur: _vm.unhideToolbar,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.invoiceAddress
                                                            .city,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.invoiceAddress,
                                                            "city",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "invoiceAddress.city",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$store.state.enableMehrwegOption
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mehrwegOption align-start mt-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "option pointer",
                                              class: {
                                                selected:
                                                  _vm.mehrwegOption.aaaSelected,
                                              },
                                              on: {
                                                "&click": function ($event) {
                                                  return _vm.selectMehrwegOption.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm.mehrwegOption.aaaSelected
                                                ? _c("v-icon", [
                                                    _vm._v(
                                                      " mdi-check-box-outline "
                                                    ),
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v(
                                                      "mdi-checkbox-blank-outline"
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "fasterGrow",
                                              staticStyle: {
                                                "padding-left": "1.9%",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Ich möchte meine Bestellung in einer Mehrweg-Verpackung der Firma " +
                                                  _vm._s(
                                                    _vm.$store.state
                                                      .mehrwegCompanyName
                                                  ) +
                                                  " erhalten. "
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "pt-1" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Hinweis: "),
                                                  ]),
                                                  _vm._v(
                                                    " Dafür musst du bereits registrietes Mitglied sein "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          !_vm.$store.getters.isKiosk
                            ? _c(
                                "div",
                                { staticClass: "mt-2" },
                                [
                                  _vm.step1Error && _vm.initialTry
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "error--text mt-2 mb-4",
                                        },
                                        [_vm._v(_vm._s(_vm.step1Error))]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "primepulsing btn-df weiter",
                                      nativeOn: {
                                        "&click": function ($event) {
                                          return _vm.finishStep1.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Weiter ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                    [
                      _c("div", { staticClass: "nice-title small" }, [
                        _vm._v("Bestellung bestätigen "),
                      ]),
                    ]
                  ),
                  _c(
                    "v-stepper-content",
                    { attrs: { id: "confirmation", step: "2" } },
                    [
                      !_vm.$store.getters.isKiosk
                        ? _c(
                            "div",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "checkoutButtonAnimationExtreme wallet-width text-none rounded100",
                                      attrs: { color: "green", dark: "" },
                                      nativeOn: {
                                        "&click": function ($event) {
                                          return _vm.doOrder.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" Zahlungspflichtig bestellen ")]
                                  ),
                                ],
                                1
                              ),
                              _c("orderconsent"),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._v("Die Bezahlung erfolgt bei Abholung."),
                      ]),
                      _c("div", [_vm._v(_vm._s(_vm.displayPaymentMethods()))]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-4 btn-df weiter grayBtn",
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              _vm.currentStep = 2
                            },
                          },
                        },
                        [_vm._v(" Zurück ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.$store.getters.isKiosk
            ? _c("div", { staticClass: "mt-4 text-center" }, [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "mt-3 checkoutButtonStyle",
                      on: { click: _vm.doOrder },
                    },
                    [_vm._v(" Bestätige deine Bestellung ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      !_vm.$store.getters.isKiosk ? [_c("ssl-seal")] : _vm._e(),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: { click: _vm.cancelOrder },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
      _vm.showKeyboard
        ? _c("div", { staticClass: "fixedVirtualKeyboard" }, [
            _c(
              "div",
              { staticClass: "superCenter" },
              [
                _c("VirtualKeyboard", {
                  attrs: { label: _vm.keyboardLabel },
                  on: {
                    enter: _vm.keyboardEnter,
                    close: function ($event) {
                      _vm.showKeyboard = false
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass: "text-center mt-3",
        staticStyle: { "margin-bottom": "2px" },
      },
      [_c("span", [_vm._v("Bestellung abschließen")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }